<app-modal
  [isVisible]="isVisible()"
  [config]="modalConfig()"
  [primaryButtonDisabled]="primaryButtonDisabled()"
  [primaryButtonLoading]="isSharing()"
  (confirmed)="onModalConfirmed()"
  (cancelled)="onModalCancelled()"
  (secondary)="onModalCancelled()"
  (closed)="onModalClosed()"
>
  @if (isSharing()) {
    <div class="modal-loader">
      <app-loader
        [title]="'modals.share_assessment.loader_title' | transloco"
        [description]="'modals.share_assessment.loader_description' | transloco"
        [size]="'small'"
        [fullScreen]="false"
      />
    </div>
  } @else if (successMessage(); as msg) {
    <app-modal-status variant="success" [title]="msg">
      <mat-icon class="modal-success-icon">check_circle</mat-icon>
    </app-modal-status>
  } @else {
    <div class="modal-content">
      <!-- Header Icon -->
      <div class="modal-header-icon modal-header-icon-lg">
        <mat-icon>share</mat-icon>
      </div>

      <!-- Description -->
      <p class="modal-description">
        {{ 'modals.share_assessment.description' | transloco }}
      </p>

      <!-- Error Message -->
      @if (error(); as err) {
        <div class="modal-error">
          <span>{{ err }}</span>
          <button
            type="button"
            (click)="clearError()"
            [attr.aria-label]="'modals.shared.clear_error_aria' | transloco"
          >
            ×
          </button>
        </div>
      }

      <!-- Form Fields -->
      <div class="field">
        <label for="share-emails">
          <mat-icon class="label-icon">email</mat-icon>
          {{ 'modals.share_assessment.recipients_label' | transloco }}
        </label>
        <input
          id="share-emails"
          type="text"
          [value]="recipientEmails()"
          (input)="onRecipientEmailsInput($event)"
          [placeholder]="'modals.share_assessment.emails_placeholder' | transloco"
          [disabled]="isSharing()"
        />
        <small>{{ 'modals.share_assessment.emails_helper' | transloco }}</small>
      </div>

      <div class="field">
        <label for="share-message">
          <mat-icon class="label-icon">message</mat-icon>
          {{ 'modals.share_assessment.message_label' | transloco }}
        </label>
        <textarea
          id="share-message"
          [value]="message()"
          (input)="onMessageInput($event)"
          [placeholder]="'modals.share_assessment.message_placeholder' | transloco"
          rows="4"
          [disabled]="isSharing()"
        ></textarea>
        <small>{{ 'modals.share_assessment.message_helper' | transloco }}</small>
      </div>
    </div>
  }
</app-modal>
